import ApiServer from '@/utils/api/ApiServer.js'

let inFlight = null

export default {
  fetchMitigationHabitats (context) {
    if (inFlight) return inFlight
    context.commit('setMitigationHabitatsLoading', true)
    inFlight = ApiServer.get('mitigationHabitats')
      .then(response => {
        const sortedData = response.data.sort((a, b) => a.name.localeCompare(b.name))
        context.commit('setMitigationHabitats', sortedData)
        return sortedData
      })
      .finally(() => {
        context.commit('setMitigationHabitatsLoading', false)
        inFlight = null
      })
    return inFlight
  },

  async deleteMitigationHabitat (context, mitigationHabitatId) {
    const response = await ApiServer.delete(`mitigationHabitats/${mitigationHabitatId}`)
    context.commit('removeMitigationHabitat', mitigationHabitatId)
    return response.data
  },

  async createMitigationHabitat (context, mitigationHabitat) {
    const response = await ApiServer.post('mitigationHabitats', mitigationHabitat)
    context.commit('addMitigationHabitat', response.data)
    return response.data
  },

  async updateMitigationHabitat (context, mitigationHabitat) {
    const response = await ApiServer.put(`mitigationHabitats/${mitigationHabitat.mitigationHabitatId}`, mitigationHabitat)
    context.commit('updateMitigationHabitat', response.data)
    return response.data
  }
}
